import React, { useState, useEffect, useRef ,useLayoutEffect } from 'react';

import {getMapSrc} from "./MapSrc.js";

export default function MapImg({mapKey, latitude, longitude}){

  let width = document.getElementById('make-container').offsetWidth;

  let height = width / 4;

  if( width < 768 ){
    height = width / 3;
  }

  let url;

  if( latitude && longitude ){
    url = getMapSrc(mapKey, latitude, longitude, 10, width, height);
  }else{
    url = getMapSrc(mapKey, 31, -173, 1, width, height);
  }

  return (<div className="make-map-cont"><img className="img-fluid" src={url}/></div>);
}
